// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__-Xyse","row":"style_row__NqrF_","edge_resize":"style_edge_resize__14kBn","edge":"style_edge__3Yeui"};